import React, { useState, useEffect } from "react";
import {
  Box,
  Divider,
  Grid,
  Stack,
  Container,
  Paper,
  Typography,
  Skeleton,
  useTheme,
} from "@mui/material";
import { green, blue, pink, purple, red, yellow } from "@mui/material/colors";
//
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import AirlineSeatReclineNormalIcon from "@mui/icons-material/AirlineSeatReclineNormal";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import Select from "react-select";
import makeAnimated from "react-select/animated";

//
import axios from "axios";
import { format } from "date-fns";
import { ToastContainer } from "react-toastify";
import {
  Cell,
  Pie,
  PieChart,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Bar,
  BarChart,
  CartesianGrid,
  YAxis,
  XAxis,
  LabelList,
} from "recharts";
import { ToastErro, formatarParaSelect } from "../utils/utils";
import { ResponsiveBar } from "@nivo/bar";

// Baseado no indice faça a colorizacao correta
const fnGetColor = (situ) => {
  switch (situ) {
    case "C": // Curriculos
      return {
        backgroundColor: green["A400"],
        color: "black",
      };
    case "AG": // Agendados
      return {
        backgroundColor: yellow["A200"],
        color: "black",
      };
    case "A": // Aprovados
      return {
        backgroundColor: "#87ceeb",
        color: "black",
      };
    case "R": // Reprovados
      return {
        backgroundColor: red["A700"],
        color: "white",
      };
    default: // Lista de espera
      return {
        backgroundColor: purple[500],
        color: "white",
      };
  }
};

const CurriculoEstatisticas = () => {
  const [dados, setDados] = useState(null);
  const [aguardar, setAguardar] = useState(true);

  // Recuperando os dados estatisticos
  useEffect(() => {
    setAguardar(true);

    axios
      .post("/curriculo_estatisticas")
      .then((resp) => {
        // Deu tudo certo vamos atualizar os dados
        setDados(resp.data);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          ToastErro(err.response.data.message);
        } else {
          ToastErro(String(err));
        }
      })
      .finally(() => {
        setAguardar(false);
      });
  }, []);

  return (
    <Container maxWidth="lg">
      <ToastContainer position="bottom-center" />
      <Typography align="center" variant="h6">
        Estatisticas dos currículos
      </Typography>
      {aguardar ? (
        <PainelSuperiorSkeleton />
      ) : dados ? (
        <PainelSuperior dados={dados} />
      ) : null}
      {dados && <AreaGraficos dados={dados} />}
    </Container>
  );
};
// SKeleton do painel superior
const PainelSuperiorSkeleton = () => {
  const itens = Array.from(Array(5)).map((_, idx) => idx);

  return (
    <Stack direction="row" justifyContent="space-around">
      {itens.map((ele, idx) => (
        <Paper
          elevation={3}
          sx={{
            mx: 0.5,
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            p: 1,
            background: ele.cor,
            color: ele.corTexto,
            height: 36,
          }}
          key={idx}
        >
          <Stack>
            <Typography variant="subtitle1" fontWeight="bold">
              <Skeleton variant="text" />
            </Typography>
            <Typography variant="caption" fontWeight="bold">
              <Skeleton variant="text" />
            </Typography>
          </Stack>
        </Paper>
      ))}
    </Stack>
  );
};
// Componente que cria o painel superior
const PainelSuperior = ({ dados }) => {
  const itens = [
    {
      ...fnGetColor("C"),
      texto: "Curriculos",
      valor: dados.curriculos,
      icone: <ContactPageIcon />,
    },
    {
      ...fnGetColor("A"),
      texto: "Aprovados",
      valor: dados.curriculos_aprovados,
      icone: <ThumbUpAltIcon />,
    },
    {
      ...fnGetColor("R"),
      texto: "Reprovados",
      valor: dados.curriculos_reprovados,
      icone: <ThumbDownOffAltIcon />,
    },
    {
      ...fnGetColor("AG"),
      texto: "Agendados",
      valor: dados.curriculos_agendados,
      icone: <EventAvailableIcon />,
    },
    {
      ...fnGetColor("L"),
      texto: "Lista de espera",
      valor: dados.curriculos_em_espera,
      icone: <AirlineSeatReclineNormalIcon />,
    },
  ];
  const sx = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    p: 1,
    minHeight: 36,
  };

  return (
    <Grid justifyContent="center" spacing={1} container>
      {itens.map((ele, idx) => (
        <Grid item key={idx} xs={idx < 4 ? 6 : 12} md={2}>
          <Paper
            elevation={3}
            sx={{
              ...sx,
              backgroundColor: ele.backgroundColor,
              color: ele.color,
            }}
          >
            <Stack
              width="100%"
              direction={{ xs: idx < 4 ? "column" : "row", md: "row" }}
              justifyContent="space-between"
              alignItems="center"
            >
              {ele.icone}
              <Typography variant="subtitle2" fontWeight="bold">
                {ele.texto}
              </Typography>
              <Typography variant="subtitle2" fontWeight="bold">
                {ele.valor}
              </Typography>
            </Stack>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};
const CORES = [blue[500], pink[500], green[500], yellow[800], red[900]];

const animetedComponents = makeAnimated();

// Estilização do componente select
const selectStyles = {
  multiValueRemove: (styles) => ({
    ...styles,
    color: "black",
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 1000,
  }),
  option: (styles) => ({
    ...styles,
    zIndex: 1000,
    color: "black",
  }),
};

const MESES = [
  [1, "JAN"],
  [2, "FEV"],
  [3, "MAR"],
  [4, "ABR"],
  [5, "MAI"],
  [6, "JUN"],
  [7, "JUL"],
  [8, "AGO"],
  [9, "SET"],
  [10, "OUT"],
  [11, "NOV"],
  [12, "DEZ"],
];
const customTooltip = (val) => {
  const { data } = val;
  return (
    <Paper sx={{ p: 1 }}>
      <Stack direction="row">
        <EventAvailableIcon />
        <Typography variant="body1">
          {data.dia}/{data.mes}/{data.ano}
        </Typography>
      </Stack>
      <Divider />
      <Typography sx={{ mt: 1 }} variant="body2">
        Quantidade: {data.valor}
      </Typography>
    </Paper>
  );
};
// Custominzando tooltip para anos
const customTooltipAno = (val) => {
  const { data } = val;

  return (
    <Paper sx={{ p: 1 }}>
      <Stack direction="row">
        <EventAvailableIcon />

        <Typography variant="body1">
          {data.chave}/{val.id}
        </Typography>
      </Stack>
      <Divider />
      <Typography sx={{ mt: 1 }} variant="body2">
        Quantidade: {val.formattedValue}
      </Typography>
    </Paper>
  );
};
// Area grafica
const AreaGraficos = ({ dados }) => {
  const {
    lista_de_anos,
    cadastro_por_mes_ano,
    cadastro,
    masculino_x_feminino,
    experiencia_x_sem_experiencia,
    estado_civil,
    escolaridade,
    disponibilidade,
  } = dados;
  const copiaDisponibilidade = disponibilidade.slice().splice(0, 10);
  // Pegar a resolucao da tela para saber em qual estamos trabalhando
  const {
    breakpoints: { values },
  } = useTheme();
  const isMobile = values["sm"] > window.innerWidth;
  //
  const [anos, setAnos] = useState(lista_de_anos[0]);
  const [mes, setMes] = useState(
    formatarParaSelect([MESES[format(new Date(), "M") - 1]])[0]
  );
  // Pega o ano selecionado e o mês  entao filtra os dados da lista
  const graf_por_ano_mes = cadastro_por_mes_ano
    .slice()
    .filter((ele) => parseInt(ele.mes) === parseInt(mes.value));

  console.log(lista_de_anos);

  return (
    <Grid sx={{ mt: 2 }} spacing={2} container>
      <Grid item xs={12}>
        <Paper sx={{ p: 1 }}>
          <Stack direction="row" spacing={1}>
            <Stack flex={1} alignItems="flex-start">
              <Typography variant="body2">ANO:</Typography>
              <Box sx={{ minWidth: { xs: "100%" } }}>
                <Select
                  value={anos}
                  styles={selectStyles}
                  options={lista_de_anos}
                  onChange={(e) => {
                    setAnos(e);
                  }}
                  components={animetedComponents}
                />
              </Box>
            </Stack>
            <Stack flex={1}>
              <Typography variant="body2">MÊS:</Typography>
              <Box sx={{ minWidth: { xs: "100%" } }}>
                <Select
                  options={formatarParaSelect(MESES)}
                  value={mes}
                  styles={selectStyles}
                  onChange={(e) => setMes(e)}
                  components={animetedComponents}
                />
              </Box>
            </Stack>
          </Stack>

          <br />
          <Paper elevation={0} sx={{ height: { xs: 500, md: 350 } }}>
            <Typography align="center" variant="subtitle1">
              Cadastro de currículos dia á dia
            </Typography>
            <ResponsiveBar
              layout={isMobile ? "horizontal" : "vertical"}
              tooltip={customTooltip}
              label={false}
              axisBottom={{
                tickSize: null,
                tickLine: null,
              }}
              axisLeft={{
                tickLine: null,
                tickSize: null,

                legend: "Quantidade",
                legendPosition: "middle",
                legendOffset: -40,
              }}
              colors={["#b71c1c"]}
              margin={{ top: 50, right: 50, bottom: 60, left: 50 }}
              padding={isMobile ? 0.5 : 0.1}
              data={graf_por_ano_mes}
              keys={["valor"]}
              indexBy="dia"
            />
          </Paper>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 1, height: 350 }} elevation={3}>
          <Typography fontWeight="bold" variant="subtitle2" align="center">
            Cadastro de currículos MÊS Á MÊS
          </Typography>
          <ResponsiveBar
            layout={isMobile ? "horizontal" : "vertical"}
            tooltip={customTooltipAno}
            label={false}
            axisBottom={{
              tickSize: null,
              tickLine: null,
            }}
            axisLeft={{
              tickLine: null,
              tickSize: null,

              legend: "Quantidade",
              legendPosition: "middle",
              legendOffset: -40,
            }}
            colors={["#b71c1c"]}
            margin={{ top: 50, right: 50, bottom: 60, left: 50 }}
            padding={isMobile ? 0.5 : 0.1}
            data={cadastro}
            keys={lista_de_anos?.map((ele) => ele.value)}
            indexBy="chave"
          />
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 1 }} elevation={3}>
          <Typography fontWeight="bold" variant="subtitle2" align="center">
            CURRÍCULOS POR SEXO
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <defs>
                <linearGradient id="Masculino" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor={CORES[0]} stopOpacity={1}></stop>
                  <stop
                    offset="100%"
                    stopColor={CORES[0]}
                    stopOpacity={0.5}
                  ></stop>
                </linearGradient>
                <linearGradient id="Feminino" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={CORES[1]} stopOpacity={1}></stop>
                  <stop
                    offset="100%"
                    stopColor={CORES[1]}
                    stopOpacity={0.6}
                  ></stop>
                </linearGradient>
              </defs>
              <Legend />
              <Pie
                nameKey="chave"
                paddingAngle={4}
                label
                data={masculino_x_feminino}
                dataKey="valor"
              >
                {masculino_x_feminino.map((ele, idx) => (
                  <Cell key={`cell-${idx}`} fill={`url(#${ele.chave})`} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 1 }} elevation={3}>
          <Typography fontWeight="bold" variant="subtitle2" align="center">
            EXPERIÊNCIA X SEM EXPERIÊNCIA
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <defs>
                <linearGradient id="Experiencia" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor={CORES[2]} stopOpacity={1}></stop>
                  <stop
                    offset="100%"
                    stopColor={CORES[2]}
                    stopOpacity={0.5}
                  ></stop>
                </linearGradient>
                <linearGradient
                  id="Sem_experiencia"
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop offset="0%" stopColor={CORES[3]} stopOpacity={1}></stop>
                  <stop
                    offset="100%"
                    stopColor={CORES[3]}
                    stopOpacity={0.6}
                  ></stop>
                </linearGradient>
              </defs>
              <Legend />
              <Pie
                nameKey="chave"
                paddingAngle={4}
                label
                data={experiencia_x_sem_experiencia}
                dataKey="valor"
              >
                {experiencia_x_sem_experiencia.map((ele, idx) => {
                  return (
                    <Cell
                      key={`cell-${idx}`}
                      fill={`url(#${ele.chave.replace(" ", "_")})`}
                    />
                  );
                })}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <GraficoBarra
          dados={escolaridade}
          titulo="CURRICULOS POR ESCOLARIDADE"
        />
      </Grid>
      <Grid item xs={12}>
        <GraficoBarra dados={estado_civil} titulo="ESTADO CIVIL" />
      </Grid>
      <Grid item xs={12}>
        <GraficoBarra
          ocultarRotulo
          dados={copiaDisponibilidade}
          titulo="LOCAIS COM MAIS DISPONIBILIDADE DO CANDIDATO (Top 10)"
        />
      </Grid>
    </Grid>
  );
};

// Recebe o objeto e cria o grafico de Barra
const GraficoBarra = ({ dados, titulo, ocultarRotulo, icone }) => {
  // CURRICULOS POR ESCOLARIDADE
  // Pegar a resolucao da tela para saber em qual estamos trabalhando
  const {
    palette: { mode },
    breakpoints: { values },
  } = useTheme();
  const isMobile = values["sm"] > window.innerWidth;
  const isDark = mode === "dark";

  return (
    <Paper sx={{ p: 1 }} elevation={3}>
      <Typography fontWeight="bold" variant="subtitle2" align="center">
        {titulo}
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={dados}>
          <defs>
            <linearGradient id="dados" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor={CORES[4]} stopOpacity={1}></stop>
              <stop
                offset="50%"
                stopColor={red["A700"]}
                stopOpacity={0.6}
              ></stop>
              <stop offset="100%" stopColor={red[500]} stopOpacity={0.6}></stop>
            </linearGradient>
          </defs>
          <Tooltip
            labelFormatter={(str) => {
              return (
                <Stack>
                  <Typography
                    fontWeight="bold"
                    sx={{ color: "black" }}
                    variant="subtitle2"
                  >
                    {str?.toString().toUpperCase()}
                  </Typography>
                  <Divider sx={{ backgroundColor: "black" }} />
                  {isDark && (
                    <Typography
                      fontWeight="bold"
                      sx={{ color: "black" }}
                      variant="body2"
                    >
                      Valor:{" "}
                      {dados.filter((ele) => ele.chave === str).length > 0 &&
                        dados.filter((ele) => ele.chave === str)[0].valor}
                    </Typography>
                  )}
                </Stack>
              );
            }}
          />

          <YAxis hide={isMobile} />
          <XAxis
            style={{ fill: `${isDark ? "#fff" : "#000"}` }}
            hide={ocultarRotulo || isMobile}
            dataKey="chave"
          />
          <CartesianGrid
            strokeOpacity={0.2}
            vertical={false}
            strokeDasharray={[2, 3]}
          />
          <Bar dataKey="valor" fill="url(#dados)">
            <LabelList
              style={{ fill: `${isDark ? "#fff" : "#000"}` }}
              dataKey="valor"
              position="top"
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
};
export default CurriculoEstatisticas;
